import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiArrowUpRight } from "react-icons/fi";
import { toImage } from "./catalogueData";
import "./Catalogue.css";

function ProductCard({ product, index = 0 }) {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);

  // A cached image can finish loading before React attaches onLoad.
  useEffect(() => {
    if (imgRef.current?.complete) setLoaded(true);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: Math.min(index, 5) * 0.07 }}
    >
      <Link to={`/product/${product.id}`} className="cat-card">
        <div className={`cat-card__media${loaded ? " is-loaded" : ""}`}>
          <img
            ref={imgRef}
            src={toImage(product.images)}
            alt={product.titre}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            onContextMenu={(e) => e.preventDefault()}
          />
          <span className="cat-card__cta">
            Voir le produit <FiArrowUpRight />
          </span>
        </div>
        <h3 className="cat-card__title">{product.titre.trim()}</h3>
      </Link>
    </motion.div>
  );
}

export default ProductCard;
